import { jsx as _jsx } from "react/jsx-runtime";
import { useAvailableSafeAreaPadding } from '@/Hooks/useSafeAreaPadding';
import { classNames } from '@standardnotes/utils';
const ModalDialogButtons = ({ children, className }) => {
    const { hasBottomInset } = useAvailableSafeAreaPadding();
    return (_jsx("div", { className: classNames('flex items-center justify-end gap-3 border-t border-border px-4 py-4', hasBottomInset && 'pb-safe-bottom', className), children: children }));
};
export default ModalDialogButtons;
